import React, { useState, useEffect } from "react";
import "../main.css";
import emailjs from "emailjs-com";

const TimeSlotTable = () => {
  // Állapotok
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [appointments, setAppointments] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    email: "",
    phone: "",
    serviceType: "haircut",
  });
  const [formErrors, setFormErrors] = useState({});

  // Szolgáltatás típusok
  const serviceTypes = [
    { value: "pedicure", label: "Gyógypedikűr" },
    { value: "swedish", label: "Svéd masszázs" },
    { value: "tradicional", label: "Tradícionális Thai masszázs" },
    { value: "manager", label: "Manager masszázs" },
    { value: "consulting", label: "Tanácsadás" },
  ];

  // Szolgáltatás helye
  const locationLevel = [
    { value: "delice", label: "Delice Éden szalon" },
    { value: "home", label: "Az Ön otthonában" },
  ];

  // Admin bejelentkezés
  const adminLogin = {
    username: "admin",
    password: "admin123",
  };

  // Bejelentkezés kezelése
  const handleLogin = (e) => {
    e.preventDefault();
    if (
      credentials.username === adminLogin.username &&
      credentials.password === adminLogin.password
    ) {
      setIsAdmin(true);
      setShowLogin(false);
      localStorage.setItem("adminLoggedIn", "true");
    } else {
      alert("Hibás felhasználónév vagy jelszó!");
    }
  };

  // Kilépés
  const handleLogout = () => {
    setIsAdmin(false);
    localStorage.removeItem("adminLoggedIn");
  };

  // Session ellenőrzése
  useEffect(() => {
    const loggedIn = localStorage.getItem("adminLoggedIn");
    if (loggedIn) {
      setIsAdmin(true);
    }
  }, []);

  // Időpont foglalás indítása
  const handleSlotClick = (slot) => {
    if (slot.status === "available") {
      setSelectedSlot(slot);
      setShowForm(true);
    }
  };

  // Űrlap adatok kezelése
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Email validáció
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  // mphone validáció
  const validatephone = (phone) => {
    const re = /^[+]{1}[0-9]{1,3}[0-9]{8,11}$/;
    return re.test(phone);
  };
  // Űrlap validáció
  const validateForm = () => {
    const errors = {};
    if (!formData.lastName.trim()) errors.lastName = "Kötelező mező";
    if (!formData.firstName.trim()) errors.firstName = "Kötelező mező";
    if (!validateEmail(formData.email)) errors.email = "Érvénytelen email cím";
    if (!validatephone(formData.phone))
      errors.phone = "Nem megfelelő formátum (+36301234567)";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Foglalás mentése
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const slotTime = selectedSlot?.time || "";
      const slotDate = selectedDate?.toLocaleDateString("hu-HU") || "";
      const templateParams = {
        lastName: formData.lastName,
        firstName: formData.firstName,
        email: formData.email,
        phone: formData.phone,
        serviceType: formData.serviceType,
        locationLevel: formData.locationLevel || "nincs megadva",
        slotDate,
        slotTime,
      };

      emailjs
        .send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          templateParams,
          process.env.REACT_APP_EMAILJS_USER_ID
        )
        .then(
          (result) => {
            console.log("Email sikeresen elküldve:", result.text);
            setShowSuccessModal(true); // ← itt nyitjuk meg az értesítést
            setTimeout(() => setShowSuccessModal(false), 3000);
          },
          (error) => {
            console.error("Email küldési hiba:", error.text);
          }
        );

      // Lokális foglalás mentése
      setAppointments({
        ...appointments,
        [selectedSlot.dateTimeKey]: {
          status: "booked",
          customer: formData,
        },
      });

      setShowForm(false);
      resetForm();
    }
  };

  // Űrlap visszaállítása
  const resetForm = () => {
    setFormData({
      lastName: "",
      firstName: "",
      email: "",
      phone: "",
      serviceType: "haircut",
    });
    setFormErrors({});
  };

  // Foglalás visszavonása
  const handleCancel = () => {
    setShowForm(false);
    resetForm();
  };

  // Időpontok generálása
  const generateTimeSlots = (date) => {
    const slots = [];
    for (let hour = 8; hour < 18; hour++) {
      const time = `${hour}:00`;
      const dateTimeKey = `${date.toDateString()} ${time}`;
      const existingAppointment = appointments[dateTimeKey] || {
        status: "available",
      };

      slots.push({
        time,
        status: existingAppointment.status,
        dateTimeKey,
        customer: existingAppointment.customer,
      });
    }
    return slots;
  };

  // Hónap napjainak generálása
  const generateDaysInMonth = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const days = [];
    const prevMonthLastDay = new Date(year, month, 0).getDate();
    const firstDayOfWeek = (firstDay.getDay() + 6) % 7; // vasárnap=6, hétfő=0, stb.

    for (let i = firstDayOfWeek - 1; i >= 0; i--) {
      const day = new Date(year, month - 1, prevMonthLastDay - i);
      days.push({ date: day, isCurrentMonth: false });
    }

    for (let day = 1; day <= lastDay.getDate(); day++) {
      const date = new Date(year, month, day);
      days.push({ date, isCurrentMonth: true });
    }

    const totalCells = Math.ceil(days.length / 7) * 7;
    const nextMonthDays = totalCells - days.length;

    for (let i = 1; i <= nextMonthDays; i++) {
      const date = new Date(year, month + 1, i);
      days.push({ date, isCurrentMonth: false });
    }

    return days;
  };

  // Időpont állapotának módosítása (admin számára)
  const handleAppointmentStatusChange = (dateTimeKey, currentStatus) => {
    let newStatus;
    if (currentStatus === "available") newStatus = "booked";
    else if (currentStatus === "booked") newStatus = "confirmed";
    else newStatus = "available";

    setAppointments((prev) => ({
      ...prev,
      [dateTimeKey]: {
        ...prev[dateTimeKey],
        status: newStatus,
      },
    }));
  };

  // Hónap váltása
  const changeMonth = (increment) => {
    setCurrentMonth(
      new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth() + increment,
        1
      )
    );
  };

  // Nap kiválasztása
  const handleDateClick = (date) => {
    if (date.getMonth() === currentMonth.getMonth()) {
      setSelectedDate(date);
    }
  };

  return (
    <div className="app mt-5">
      <div className="admin-controls">
        {isAdmin ? (
          <>
            <span className="admin-badge">Admin mód</span>
            <button onClick={handleLogout}>Kilépés</button>
          </>
        ) : (
          <button onClick={() => setShowLogin(true)}>
            Admin bejelentkezés
          </button>
        )}
      </div>

      {showLogin && (
        <div className="login-modal">
          <div className="login-content">
            <h3>Admin bejelentkezés</h3>
            <form onSubmit={handleLogin}>
              <div>
                <label>Felhasználónév:</label>
                <input
                  type="text"
                  value={credentials.username}
                  onChange={(e) =>
                    setCredentials({ ...credentials, username: e.target.value })
                  }
                />
              </div>
              <div>
                <label>Jelszó:</label>
                <input
                  type="password"
                  value={credentials.password}
                  onChange={(e) =>
                    setCredentials({ ...credentials, password: e.target.value })
                  }
                />
              </div>
              <div className="login-buttons">
                <button type="submit">Bejelentkezés</button>
                <button type="button" onClick={() => setShowLogin(false)}>
                  Mégse
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Időpont foglalása: {selectedSlot?.time}</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Vezetéknév:</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className={formErrors.lastName ? "error" : ""}
                />
                {formErrors.lastName && (
                  <span className="error-message">{formErrors.lastName}</span>
                )}
              </div>

              <div className="form-group">
                <label>Keresztnév:</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className={formErrors.firstName ? "error" : ""}
                />
                {formErrors.firstName && (
                  <span className="error-message">{formErrors.firstName}</span>
                )}
              </div>

              <div className="form-group">
                <label>Email cím:</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className={formErrors.email ? "error" : ""}
                />
                {formErrors.email && (
                  <span className="error-message">{formErrors.email}</span>
                )}
              </div>

              <div className="form-group">
                <label>Telefonszám:</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  placeholder="+36301234567"
                  onChange={handleInputChange}
                  className={formErrors.phone ? "error" : ""}
                />
                {formErrors.phone && (
                  <span className="error-message">{formErrors.phone}</span>
                )}
              </div>

              <div className="form-group">
                <label>Szolgáltatás típusa:</label>
                <select
                  name="serviceType"
                  value={formData.serviceType}
                  onChange={handleInputChange}
                >
                  {serviceTypes.map((service) => (
                    <option key={service.value} value={service.value}>
                      {service.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Szolgáltatás helye:</label>
                <select
                  name="locationLevel"
                  value={formData.locationLevel}
                  onChange={handleInputChange}
                >
                  {locationLevel.map((locationLevel) => (
                    <option
                      key={locationLevel.value}
                      value={locationLevel.value}
                    >
                      {locationLevel.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mt-4 mb-4 form-check">
                <h6>
                  A Küldés gomb megnyomásával elismerem, hogy elolvastam,
                  megértettem és elfogadom az Adatvédelmi Tájékoztatót, mely
                  alapján az oldal az adataimat kezeli.
                </h6>
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="exampleCheck1"
                  required
                />
                <label className="form-check-label" htmlFor="exampleCheck1">
                  Hozzájárulok ahhoz, hogy a megadott személyes adataimat a
                  Csillag Masszázs Pedikűr - hozzájárulásom visszavonásáig -
                  közvetlen üzletszerzési célra (tájékoztatás, közvélemény- vagy
                  piackutatás, illetve egyéb tájékoztatás) felhasználja.
                </label>
              </div>
              <div className="form-actions">
                <button type="button" onClick={handleCancel}>
                  Mégse
                </button>
                <button type="submit">Mentés</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showSuccessModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Sikeres foglalás!</h3>
            <p>Köszönjük, hogy lefoglalta az időpontot.</p>
            <button onClick={() => setShowSuccessModal(false)}>Bezárás</button>
          </div>
        </div>
      )}

      <h1>Időpontfoglaló</h1>

      <div className="calendar-controls">
        <button onClick={() => changeMonth(-1)}>&lt; Előző hónap</button>
        <h2>
          {currentMonth.toLocaleString("hu-HU", {
            month: "long",
            year: "numeric",
          })}
        </h2>
        <button onClick={() => changeMonth(1)}>Következő hónap &gt;</button>
      </div>

      <div className="calendar">
        <div className="weekdays">
          {[
            "Hétfő",
            "Kedd",
            "Szerda",
            "Csütörtök",
            "Péntek",
            "Szombat",
            "Vasárnap",
          ].map((day) => (
            <div key={day} className="weekday">
              {day}
            </div>
          ))}
        </div>

        <div className="days">
          {generateDaysInMonth().map((day, index) => (
            <div
              key={index}
              className={`day
    ${day.isCurrentMonth ? "current-month" : "other-month"}
    ${
      selectedDate && day.date.toDateString() === selectedDate.toDateString()
        ? "selected"
        : ""
    }
    ${day.date.toDateString() === new Date().toDateString() ? "today" : ""}
  `}
              onClick={() => handleDateClick(day.date)}
            >
              {day.date.getDate()}
            </div>
          ))}
        </div>
      </div>

      {selectedDate && (
        <div className="time-slots">
          <h3>Időpontok: {selectedDate.toLocaleDateString("hu-HU")}</h3>
          <div className="slots-container">
            {generateTimeSlots(selectedDate).map((slot, index) => (
              <div
                key={index}
                className={`time-slot ${slot.status}`}
                onClick={() =>
                  isAdmin
                    ? handleAppointmentStatusChange(
                        slot.dateTimeKey,
                        slot.status
                      )
                    : handleSlotClick(slot)
                }
              >
                {slot.time}
                <div className="status-indicator">
                  {slot.status === "available"
                    ? "Szabad"
                    : slot.status === "booked"
                    ? "Foglalt"
                    : "Visszaigazolt"}
                </div>
                {slot.status === "booked" && slot.customer && (
                  <div className="customer-info">
                    {slot.customer.lastName} {slot.customer.firstName}
                  </div>
                )}
                {isAdmin && (
                  <div className="admin-hint">(Kattints a módosításhoz)</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TimeSlotTable;
